var CAT = window.BB_CATALOGUE || [];

/* The Commute view (?view=commute). On a Commute flight, bootleg.scent_notes
   holds the FLIGHT name — it is the key the flight icon is looked up by — so a
   picker labelled from it reads "Off the Clock" where the shopper needs to see
   the three scents in the box. bootleg.ct_scents carries those, and it is read
   ONLY on this view; every other page falls through to the labels it has always
   had. Two fields because the one field has two jobs. */
var VIEW = '';
try { VIEW = new URLSearchParams(location.search).get('view') || ''; } catch(e){}

/* hero autoplay — browsers only allow it muted, and only after a nudge */
(function(){
  var v=document.getElementById('heroVid'); if(!v) return;
  v.muted=true; v.defaultMuted=true; v.removeAttribute('controls');
  function go(){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  go(); v.addEventListener('loadeddata',go); v.addEventListener('canplay',go);
  v.loop=true;
  v.addEventListener('ended',function(){ v.currentTime=0; go(); });
  v.addEventListener('pause',function(){ if(document.getElementById('qs').hidden) go(); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) go(); });
})();
// Editorial tiles: assortment not chosen yet — placeholder so the frame is reviewable.
var EDITORIAL = window.BB_EDITORIAL || {};

var qs=document.getElementById('qs'), modal=qs.querySelector('.qs__modal'),
    grid=document.getElementById('qs-bodyGrid'), blank=document.getElementById('qs-blank'),
    eyebrow=document.getElementById('qs-eyebrow'), nm=document.getElementById('qs-name'),
    ctEl=document.getElementById('qs-count'), thumbs=document.getElementById('qs-thumbs'),
    scentsBox=document.getElementById('qs-scents'),
    scentName=document.getElementById('qs-scentname'),
    swatches=document.getElementById('qs-swatches'),
    stage=document.getElementById('qs-stage'), badge=document.getElementById('qs-badge'),
    title=document.getElementById('qs-title'), price=document.getElementById('qs-price'),
    desc=document.getElementById('qs-desc'), qty=document.getElementById('qs-qty'),
    add=document.getElementById('qs-add'),
    link=document.getElementById('qs-link'),
    pickBox=document.getElementById('qs-pick'), picker=document.getElementById('qs-variant'),
    amz=document.getElementById('qs-amz');

/* One class, set once, is what turns on the Commute purchase block in the
   stylesheet. Every normal page leaves the drawer exactly as it was. */
if(VIEW && qs) qs.classList.add('qs--ct');
var cur=[], idx=0, lastFocus=null;

function byHandle(h){ return CAT.filter(function(p){return p.handle===h;})[0]; }
function byHandles(list){ return (list||[]).map(byHandle).filter(Boolean); }

/* Variation grouping — ADR-UI-031. Group by the Amazon parent via
   bootleg.product_group. Until that metafield is populated, product_type is the
   interim proxy. This is the ONLY place the rule lives. */
function groupKeyOf(p){ return (p && (p.group || p.type)) || ''; }

/* Pack size is the SECOND axis. Variations must match on both, so a single bar
   offers the other single bars and a 3 pack offers the other 3 packs — without
   this, every scent appears twice and the row is noise.
   INTERIM: read off the title until FILL_pack_size comes back in the sheet. */
function packOf(p){
  if(p && p.pack) return p.pack;          /* bootleg.pack_size, authoritative */
  var t = (p && p.title) || '';
  var m = t.match(/(\d+)\s*[- ]?\s*Pack/i);
  if(m) return m[1] + ' Pack';
  if(/Multi\s*Pack/i.test(t)) return 'Multi Pack';
  return 'Single';
}
/* CATALOGUE ORDER, always — never "the one you clicked, then the rest".
   This list draws the icon row, so ordering it around the active product made
   the icons rearrange themselves on every click, and made the same group read
   in a different order on each card. Which product is active is carried by
   aria-current and by the key the drawer opens with, not by position. */
function siblingsOf(p){
  var k = groupKeyOf(p);
  if(!k) return [p];
  var size = packOf(p);
  var list = CAT.filter(function(q){
    return groupKeyOf(q)===k && packOf(q)===size; });
  return list.length ? list : [p];
}

function pick(key,source){
  if(source==='family') return CAT.filter(function(p){return p.family===key;});
  if(source==='ritual') return CAT.filter(function(p){return (p.rituals||[]).indexOf(key)>-1;});
  if(source==='group')  { var me=byHandle(key); return me? siblingsOf(me) : []; }
  return byHandles(EDITORIAL[key]);
}
/* Scent swatches replace the old thumbnail rail. One swatch per sibling scent,
   drawn as a fragrance-note icon; falls back to the product thumbnail while an
   icon is missing so no scent becomes unreachable. */
var ICON_SVG = window.BB_SCENT_ICON_SVG || {};
var ICON_MAP = window.BB_SCENT_ICON_MAP || {};
var ICON_COL = window.BB_SCENT_ICON_COLOR || {};
/* Family naming, shared by the collection card, the drawer and anything else
   that shows a product. Grid blocks override the global defaults. */
var FAM = Object.assign({}, window.BB_FAMILY_LABELS_DEFAULT || {}, window.BB_FAMILY_LABELS || {});
/* No block for this group? Use the group's own name from bootleg.product_group.
   It is Lauren's value, so it is a real label — better than falling back to the
   product's full marketplace title, which is written for Amazon search. */
function familyLabelOf(p){ return FAM[groupKeyOf(p)] || groupKeyOf(p) || null; }

/* The line under the price names THIS product within its family, so the family
   words shouldn't repeat there. Only a trailing run that the family label also
   ends with is removed:
     "American Summer Air Freshener"  in "Car Air Freshener"     -> "American Summer"
     "Cold Brew Scrub Bar"            in "Hand Crafted Bar Soap" -> unchanged
   The second is the point of the rule — "Bar" is not how that family label ends,
   so the bar keeps its name. */
function subLabelOf(p){
  var fam = familyLabelOf(p);
  if(!fam) return p.title;
  if(p.title === fam) return '';
  var t = p.title.split(/\s+/), f = fam.split(/\s+/), n = 0;
  while(n < t.length - 1 && n < f.length &&
        t[t.length-1-n].toLowerCase() === f[f.length-1-n].toLowerCase()) n++;
  var rest = t.slice(0, t.length - n).join(' ').trim();
  return rest || p.title;
}

/* The icon now comes from bootleg.icon on the product. Lauren's values vary in
   case (Grapefruit / SW / Mint), so match lowercased against the artwork keys.
   Falls back to the old scent-name map for anything not yet attributed. */
function iconKeyFor(p){
  var direct = (p.icon || '').trim().toLowerCase();
  if(direct && ICON_SVG[direct]) return direct;
  var viaScent = ICON_MAP[p.notes];
  return (viaScent && ICON_SVG[viaScent]) ? viaScent : null;
}
function iconFor(p){ var k = iconKeyFor(p); return k ? ICON_SVG[k] : null; }
function iconColorFor(p){ var k = iconKeyFor(p); return (k && ICON_COL[k]) || null; }
/* --------------------------------------------------------------------------
   Two lists, deliberately separate — this mirrors J.Crew.

     cur    the drawer's assortment. Drives the thumbnail rail. Shop view only.
     sibs   the ACTIVE product's scent variations. Drives the icon row.
     active what is committed and would go in the bag.
     shown  what the stage is currently displaying — active, or a hover preview.

   Hovering an icon previews that scent. It never commits: moving away snaps
   back to active, and only a click changes active.
   -------------------------------------------------------------------------- */
var sibs=[], active=null;

/* Every sibling's images are built ONCE, then hovering just swaps which pane is
   visible. Re-rendering the stage on hover made the images re-decode, which is
   what caused the flash and jump. Nothing is created or destroyed on hover. */
function buildStage(){
  stage.innerHTML = sibs.map(function(p){
    /* hero before thumb: the thumb is 240px and looked blurry blown up. */
    var src = p.images.length ? p.images : [p.hero || p.thumb];
    var wh  = p.images.length ? (p.imgwh || []) : (p.herowh ? [p.herowh] : []);
    var imgs = src.map(function(s, i){
      /* width/height reserve the box. A phone lets each photo keep its own
         shape, and without these a lazy image has no height, never reaches the
         viewport, and never loads. */
      var d = wh[i];
      var size = d ? ' width="'+d[0]+'" height="'+d[1]+'"' : '';
      /* The same numbers as custom properties, so the phone stylesheet can work
         out the photo's natural height at the current width and trim a fixed
         amount off it. Desktop ignores them. */
      var vars = d ? ' style="--iw:'+d[0]+';--ih:'+d[1]+'"' : '';
      return '<img src="'+s+'" alt=""'+size+vars+' loading="lazy">'; }).join('');
    return '<div class="qs__pane" data-h="'+p.handle+'" hidden>'+imgs+'</div>';
  }).join('');
}
function renderStage(p){
  var found=false;
  [].forEach.call(stage.children,function(el){
    var on = el.getAttribute('data-h')===p.handle;
    el.hidden = !on; if(on) found=true;
  });
  if(!found){ buildStage(); renderStage(p); return; }
  stage.scrollTop=0; stage.scrollLeft=0;   /* phones swipe sideways */
}
function sameProduct(a,b){ return a && b && a.handle===b.handle; }

/* Shop view: square thumbnails down the left, one per product in the assortment. */
function drawThumbs(){
  thumbs.innerHTML='';
  cur.forEach(function(p){
    var li=document.createElement('li'), b=document.createElement('button');
    b.type='button'; b.className='qs__thumb';
    b.setAttribute('aria-current', sameProduct(p,active)?'true':'false');
    b.setAttribute('aria-label',p.title);
    b.innerHTML='<span class="box"><img src="'+p.thumb+'" alt="" loading="lazy"></span>'+
                '<span class="nm">'+p.title+'</span>';
    b.onclick=function(){ select(p); };
    li.appendChild(b); thumbs.appendChild(li);
  });
}

/* Icon row: the active product's scent siblings. Present in BOTH views. */
function drawSwatches(){
  swatches.innerHTML='';
  if(sibs.length<2){ scentsBox.hidden=true; return; }
  scentsBox.hidden=false;
  sibs.forEach(function(p){
    var li=document.createElement('li'), b=document.createElement('button');
    b.type='button'; b.className='qs__swatch';
    b.setAttribute('aria-current', sameProduct(p,active)?'true':'false');
    b.setAttribute('aria-label', p.notes || p.title);
    var svg = iconFor(p), col = iconColorFor(p);
    if(col) b.style.setProperty('--sw-color', col);
    b.innerHTML = svg
      ? '<span class="qs__swatch-ico">'+svg+'</span>'
      : '<span class="qs__swatch-img"><img src="'+p.thumb+'" alt="" loading="lazy"></span>';
    b.onclick        =function(){ select(p); };
    b.onmouseenter   =function(){ preview(p); };
    b.onfocus        =function(){ preview(p); };
    b.onmouseleave   =function(){ preview(null); };
    b.onblur         =function(){ preview(null); };
    li.appendChild(b); swatches.appendChild(li);
  });
}

/* Same list as the icons, as a real <select>. Icons are hover-driven, which
   touch devices don't have — this is the accessible, mobile-safe path to the
   same products. Labels use the scent when there is one, else the title; on the
   Commute view they name the three scents in the box instead, because there the
   scent field holds the flight's name. */
function drawPicker(){
  if(sibs.length<2){ pickBox.hidden=true; picker.innerHTML=''; return; }
  pickBox.hidden=false;
  picker.innerHTML = sibs.map(function(p){
    var label = (VIEW && p.ctScents) ? p.ctScents : (p.notes ? p.notes : p.title);
    return '<option value="'+p.handle+'"'+(sameProduct(p,active)?' selected':'')+'>'+label+'</option>';
  }).join('');
}
picker.onchange = function(){ var p = byHandle(picker.value); if(p) select(p); };

/* Temporary look at a scent. Images and the name change; nothing commits. */
function preview(p){
  var show = p || active; if(!show) return;
  renderStage(show);
  scentName.textContent = subLabelOf(show);
}

/* Commit — this is what a click does. */
function select(p){
  var groupChanged = !active || groupKeyOf(active)!==groupKeyOf(p) || packOf(active)!==packOf(p);
  active = p;
  sibs = siblingsOf(active);
  if(groupChanged || !stage.children.length) buildStage();
  drawSwatches();
  drawPicker();
  [].forEach.call(thumbs.querySelectorAll('.qs__thumb'),function(b){
    b.setAttribute('aria-current', b.getAttribute('aria-label')===active.title?'true':'false'); });
  paint();
}

function paint(){
  var p=active; if(!p) return;
  renderStage(p);
  /* The scent is named above the icon row, so it isn't repeated at the top. */
  badge.hidden=true; badge.textContent='';
  /* Heading names the family; the line under the price names this one. */
  scentName.textContent = subLabelOf(p);
  title.textContent = familyLabelOf(p) || p.title;
  price.textContent = p.price;
  desc.textContent=p.description;
  if(link) link.href = p.url;          /* View full details -> the product page */
  /* Commute view: Amazon is the primary action and its destination belongs to
     the product, not the page — so it is re-pointed every time the active flight
     changes, including from the scent dropdown. A product with no
     bootleg.amazon_url shows Add to Bag alone rather than a button that would
     send the shopper to the wrong listing. */
  if(amz){
    var amzUrl = VIEW ? (p.amazonUrl || '') : '';
    amz.hidden = !amzUrl;
    if(amzUrl) amz.href = amzUrl;
  }
  qty.value=1;
  add.className='qs__add'; add.textContent='Add to bag';
}

[].forEach.call(document.querySelectorAll('[data-qty]'),function(b){
  b.onclick=function(){ qty.value=Math.max(1,(parseInt(qty.value,10)||1)+parseInt(b.dataset.qty,10)); };
});
add.onclick=function(){
  var p=active; if(!p||!p.available) return;
  var q=Math.max(1,parseInt(qty.value,10)||1);
  add.disabled=true; add.textContent='Adding…';
  fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{
    method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:p.variantId,quantity:q}]})})
  .then(function(r){return r.json();})
  .then(function(){
    add.classList.add('is-done'); add.textContent='Added ✓';
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js')
      .then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(e){e.textContent=c.item_count;});
        var b=document.querySelector('.cart-count-bubble'); if(b) b.hidden=false;
        document.dispatchEvent(new CustomEvent('bb:cart:updated',{detail:c}));
      });
    setTimeout(function(){add.className='qs__add';add.textContent='Add to bag';add.disabled=false;},1700);
  })
  .catch(function(){add.textContent='Try again';add.disabled=false;});
};
function open(d){
  cur = (d.handles && d.handles.length) ? byHandles(d.handles) : pick(d.key,d.source);
  eyebrow.textContent = d.label || d.title || '';
  /* A collection card opens one product and its variations — no rail, so the
     hero image takes the space the rail would have used. Everything else is a
     mix of different products and keeps the rail. Panel width never changes. */
  var variations = d.source === 'group';
  qs.classList.toggle('qs--variations', variations);
  if(!cur.length){
    grid.hidden=true; blank.hidden=false;
    blank.innerHTML='<strong>No products assigned to “'+d.name+'” yet.</strong><br>'+
      'The frame and the modal are built. Assign products and this fills in automatically.';
  } else {
    grid.hidden=false; blank.hidden=true;
    /* siblingsOf no longer floats the clicked product to the front, so the
       product to open has to be named rather than assumed to be first. For a
       shop or an editorial tile there is no single product, and the first is
       right. */
    var want = d.key ? byHandle(d.key) : null;
    active = (want && cur.indexOf(want) > -1) ? want : cur[0];
    /* Thumbnails only in shop view. The icon row is in both — it always shows
       the ACTIVE product's scent siblings, which in variations view is the
       whole list and in shop view is a subset of the catalogue. */
    if(variations){ thumbs.innerHTML=''; }
    else { drawThumbs(); }
    select(active);
  }
  lastFocus=document.activeElement;
  var hv=document.querySelector('.hero video'); if(hv) hv.pause();
  qs.hidden=false; document.body.style.overflow='hidden';
  requestAnimationFrame(function(){ qs.classList.add('is-open'); });
  setTimeout(function(){ modal.querySelector('.qs__close').focus(); },60);
}
function close(){
  qs.classList.remove('is-open'); document.body.style.overflow='';
  var hv=document.querySelector('.hero video'); if(hv) hv.play().catch(function(){});
  setTimeout(function(){ qs.hidden=true; },320);
  [].forEach.call(document.querySelectorAll('[aria-pressed]'),function(c){c.setAttribute('aria-pressed','false');});
  if(lastFocus&&lastFocus.focus) lastFocus.focus();
}
[].forEach.call(qs.querySelectorAll('[data-close]'),function(e){ e.onclick=close; });
document.addEventListener('keydown',function(e){
  if(qs.hidden) return;
  if(e.key==='Escape') close();
  if(e.key==='Tab'){
    var f=modal.querySelectorAll('button,a[href],input');
    if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  }
});

/* ---------- public entry point (ADR-UI-029) ----------
   Any section opens the one drawer with:
     document.dispatchEvent(new CustomEvent('bb:drawer:open',
       {detail:{title, name, key, handles, source}}));               */
document.addEventListener('bb:drawer:open',function(e){ open(e.detail||{}); });

/* ---------- collection grid ----------
   Quick Shop opens the shared drawer with the clicked product first,
   followed by its scent siblings. */
[].forEach.call(document.querySelectorAll('[data-bb-quick]'),function(btn){
  btn.addEventListener('click',function(){
    document.dispatchEvent(new CustomEvent('bb:drawer:open',{detail:{
      title:'Quick Shop', name:btn.getAttribute('aria-label')||'',
      key:btn.dataset.handle, source:'group'
    }}));
  });
});

/* Fragrance icon row under each card — one icon per scent the family comes in
   (ADR-UI-031). Uses the same icon set as the drawer swatches. Scents with no
   icon yet are recorded in data-scents but draw nothing. */
[].forEach.call(document.querySelectorAll('[data-bb-fragrance-icons]'),function(row){
  var me = byHandle(row.dataset.handle); if(!me) return;
  /* scent_notes only. fragrance_family is a broader grouping, not a scent,
     so falling back to it would list the wrong things. */
  var scents = siblingsOf(me)
        .map(function(p){ return p.notes || ''; })
        .filter(Boolean)
        .filter(function(v,i,a){ return a.indexOf(v)===i; });
  row.dataset.scents = scents.join('|');
  row.dataset.group  = groupKeyOf(me);
  if(!scents.length) return;

  /* One icon per sibling. Hovering swaps the card's image to that scent, so the
     icon and the thing it stands for are visibly connected. Clicking opens the
     shared drawer on that product. */
  /* Nothing to distinguish when there are no siblings — clear the line rather
     than repeating the product's own name under the price. */
  if(siblingsOf(me).length < 2){
    var solo = row.closest('.pc') || row.parentElement;
    var line = solo && solo.querySelector('[data-bb-scent]');
    if(line) line.textContent = '';
    return;
  }
  /* This row appears on a collection card AND on the product page, which have
     different markup. Resolve the image and the scent line from whichever we're
     in — previously it only looked for .pc, so on a product page hovering an
     icon silently did nothing. */
  var card  = row.closest('.pc');
  var scope = card || row.closest('.pdp') || document;
  var still = card ? card.querySelector('.pc__still')
                   : scope.querySelector('.pdp__img');
  var original = still ? still.getAttribute('src') : null;
  var scentLine = scope.querySelector('[data-bb-scent]');
  if(scentLine) scentLine.textContent = subLabelOf(me);   /* same rule as the drawer */
  var ownScent = scentLine ? scentLine.textContent : '';

  function show(p){
    if(still && p.images[0]) still.src = p.images[0];
    if(scentLine) scentLine.textContent = p.notes || subLabelOf(p);
  }
  function reset(){
    if(still && original) still.src = original;
    if(scentLine) scentLine.textContent = ownScent;
  }
  /* A click STICKS. Hover is a preview and reset() undoes it, so committing
     means moving the thing reset() restores to — otherwise the card snapped
     back to the first scent the moment the pointer left. */
  function commit(p, btn){
    if(still && p.images[0]){ still.src = p.images[0]; original = p.images[0]; }
    if(scentLine){
      scentLine.textContent = p.notes || subLabelOf(p);
      ownScent = scentLine.textContent;
    }
    [].forEach.call(row.querySelectorAll('.pc__icon'), function(el){
      el.setAttribute('aria-current','false');
    });
    if(btn) btn.setAttribute('aria-current','true');
  }

  row.innerHTML = '';
  siblingsOf(me).forEach(function(p){
    var svg = iconFor(p);
    var b = document.createElement('button');
    b.type='button'; b.className='pc__icon';
    if(!svg){
      /* No icon artwork for this scent yet. Fall back to the product's own
         thumbnail rather than skipping it — previously a scent with no icon
         vanished from the row entirely and became unreachable here. */
      if(!p.thumb) return;
      b.className += ' pc__icon--photo';
      svg = '<img class="bb-ico" src="' + p.thumb + '" alt="">';
    }
    /* aria-label only — no title attribute, so no browser tooltip. The scent
       line below the price is what names it. */
    b.setAttribute('aria-label', p.notes || p.title);
    b.setAttribute('aria-current', p.handle===me.handle ? 'true' : 'false');
    var col = iconColorFor(p); if(col) b.style.setProperty('--sw-color', col);
    b.innerHTML = svg;
    b.onmouseenter = function(){ show(p); };
    b.onfocus      = function(){ show(p); };
    b.onmouseleave = reset;
    b.onblur       = reset;
    b.onclick = row.hasAttribute('data-nav')
      ? function(){ window.location.href = p.url; }      /* product page: go there */
      : function(){                                       /* collection card: stick, then drawer */
          commit(p, b);
          document.dispatchEvent(new CustomEvent('bb:drawer:open',{detail:{
            title:'Quick Shop', name:p.title, key:p.handle, source:'group' }}));
        };
    row.appendChild(b);
  });
});
